import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { extractContextsFromAction } from './utils';
export var ContextsSymbol = Symbol('@@contexts');
var pipe = function pipe(functions) {
  return function (args) {
    return functions.reduce(function (acc, fn) {
      return fn(acc);
    }, args);
  };
};
export var createApplyMiddlewares = function createApplyMiddlewares(middlewares) {
  return function (action) {
    return pipe(middlewares)(action);
  };
};
var sideEffectToMiddleware = function sideEffectToMiddleware(sideEffect) {
  return function (action) {
    var _extractContextsFromA;
    sideEffect({
      action: action,
      contexts: (_extractContextsFromA = extractContextsFromAction(action)) !== null && _extractContextsFromA !== void 0 ? _extractContextsFromA : {}
    });
    return action;
  };
};
export var createActionBus = function createActionBus(config) {
  var _config$sideEffects;
  var middlewares = ((_config$sideEffects = config === null || config === void 0 ? void 0 : config.sideEffects) !== null && _config$sideEffects !== void 0 ? _config$sideEffects : []).map(function (sideEffect) {
    return sideEffectToMiddleware(sideEffect);
  });
  var applyMiddlewares = createApplyMiddlewares(middlewares);
  var subscribers = new Map([]);
  var updateSubscriber = function updateSubscriber(_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      selectors = _ref2[0],
      subscription = _ref2[1];
    return function (action) {
      if (selectors.includes(action.type)) {
        subscription(action.payload);
      }
    };
  };
  var updateSubscibers = function updateSubscibers(action) {
    subscribers.forEach(function () {
      for (var _len = arguments.length, subscriber = new Array(_len), _key = 0; _key < _len; _key++) {
        subscriber[_key] = arguments[_key];
      }
      return updateSubscriber(subscriber)(action);
    });
  };
  var dispatchWithContexts = function dispatchWithContexts(contexts) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var type = args[0],
        payload = args[1];
      var action = {
        type: type,
        payload: payload !== null && payload !== void 0 ? payload : {}
      };
      if (contexts) {
        // This attaches contexts from the module for analytics
        // It is delibrately excluded from types and
        // made readonly
        Object.defineProperty(action, ContextsSymbol, {
          value: contexts,
          writable: false,
          enumerable: false
        });
      }
      updateSubscibers(applyMiddlewares(action));
    };
  };
  return {
    dispatch: dispatchWithContexts(),
    dispatchWithContexts: dispatchWithContexts,
    on: function on() {
      for (var _len3 = arguments.length, _ref3 = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        _ref3[_key3] = arguments[_key3];
      }
      var action = _ref3[0],
        callback = _ref3[1];
      subscribers.set(callback, [action]);
      return function () {
        subscribers.delete(callback);
      };
    }
  };
};
export var createActionBusWithContextsFactory = function createActionBusWithContextsFactory(config) {
  var _createActionBus = createActionBus(config),
    on = _createActionBus.on,
    dispatchWithContexts = _createActionBus.dispatchWithContexts;
  return function (contexts) {
    return function (_ref4) {
      var module = _ref4.data,
        reasons = _ref4.reasons;
      return {
        on: on,
        dispatch: dispatchWithContexts(_objectSpread(_objectSpread({}, contexts), {}, {
          module: module,
          reasons: reasons
        }))
      };
    };
  };
};